export default {
      id: "oc-vmware-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-vmware",
      toString: function () {
        return this.url;
      }
    }